<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="closeSkipForNowModal($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="skip-confirmation-modal-popup">
    <div class="modal-header">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="skip-file-modal-container" modal-title>
        {{cfetLabels.cfet_doc_upload.skip_for_now_heading}}</h2>
      <p id="skip-subheading">{{cfetLabels.cfet_doc_upload.skip_for_now_desc}}</p>
      <div class="corner-button">
        <button type="button" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="closeSkipForNowModal($event, 'openModal')" (keyup)="closeSkipForNowModal($event,'openModal')">
          <em aria-label="Close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" id="confirmation-buttons-section" modal-content>
      <div class="col-md-12" id="confirmation-buttons">
        <button type="button" id="btn-skip" (click)="skipUploadForNow($event)" (keyup.enter)="skipUploadForNow($event)"
          class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.skip_photo_upload}}</button>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>